export default "__VITE_ASSET__O82bk$Wz__"